export default {"src":"/_next/static/media/pepe.5da81140.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};